import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../ErrorFallback";

const LogError = (error, info) => {
  console.error(error, info);
  return;
};

const ErrorBoundaryWrapper = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={LogError}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
